import React from "react";
import withStyles from "elevate-ui/withStyles";

const BlankCanvas = ({ classes }) => (
  <svg
    className={classes.root}
    viewBox="0 0 400 320"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        x1="49.9946628%"
        y1="99.9937813%"
        x2="49.9946628%"
        y2="-0.000220870294%"
        id="linearGradient-1"
      >
        <stop stopColor="#808080" stopOpacity="0.25" offset="0%" />
        <stop stopColor="#808080" stopOpacity="0.12" offset="54%" />
        <stop stopColor="#808080" stopOpacity="0.1" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="blankCanvas">
        <path
          d="M129.661662,11.7499401 C141.357357,1.78586826 159.715716,-0.256766467 176.428428,0.536526946 C228.916917,3.03520958 276.296296,27.2862275 317.281281,54.7219162 C332.12012,64.651497 346.726727,75.3552096 356.356356,89.0328144 C375.975976,116.874731 370.146146,155.443353 342.886887,178.37988 C333.60961,186.182515 322.366366,192.176287 310.822823,197.468743 C290.298298,206.896287 268.152152,214.46515 244.856857,216.630419 C228.248248,218.163353 211.431431,216.917844 194.914915,214.775569 C148.776777,208.774132 103.495495,195.529581 65.5255255,172.872814 C48.8768769,162.935569 33.1851852,150.58012 26.3223223,134.511138 C19.4594595,118.442156 23.8518519,98.0541317 40.8528529,88.5231138 C47.8838839,84.5873054 56.2922923,82.8091018 64.5205205,81.1382036 C76.6366366,78.6816766 88.9449449,76.2596407 99.8758759,71.2661078 C111.171171,66.1077844 124.540541,56.1322156 122.298298,44.7118563 C119.911912,32.4752096 117.981982,21.714012 129.661662,11.7499401 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M274.254254,256.724311 C274.254254,256.724311 284.288288,239.712575 299.395395,234.811018 C305.746612,232.793613 311.242839,228.858935 315.059059,223.597605 C316.850608,221.086681 318.397317,218.42351 319.67968,215.641677"
          id="Path"
          stroke="#535461"
          strokeWidth="2"
        />
        <path
          d="M329.185185,212.495329 C327.463463,214.097246 319.443443,215.748982 319.443443,215.748982 C319.443443,215.748982 321.409409,208.126467 323.131131,206.528383 C324.852667,204.928279 327.603494,204.966884 329.275275,206.614611 C330.947056,208.262338 330.906722,210.895225 329.185185,212.495329 L329.185185,212.495329 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M324.648649,226.287904 C322.294294,226.736287 314.638639,223.954012 314.638639,223.954012 C314.638639,223.954012 320.620621,218.588743 322.970971,218.128862 C325.324953,217.681214 327.612379,219.144787 328.08008,221.397844 C328.547781,223.650901 327.018647,225.840256 324.664665,226.287904 L324.648649,226.287904 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M308.132132,241.211018 C305.861862,240.444551 300.708709,234.351138 300.708709,234.351138 C300.708709,234.351138 308.716717,232.603593 310.974975,233.354731 C312.474248,233.816471 313.595,235.018703 313.904124,236.496834 C314.213247,237.974965 313.662323,239.497462 312.464251,240.475969 C311.266179,241.454475 309.608622,241.73572 308.132132,241.211018 L308.132132,241.211018 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M292.976977,249.810778 C290.610611,249.427545 284.452452,244.25006 284.452452,244.25006 C284.452452,244.25006 292.024024,241.23018 294.39039,241.605749 C295.933634,241.835147 297.229475,242.839726 297.784462,244.236944 C298.339449,245.634161 298.068167,247.208983 297.07392,248.36172 C296.079674,249.514458 294.515479,250.067702 292.976977,249.810778 L292.976977,249.810778 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M307.935936,217.998563 C307.935936,220.297964 312.276276,226.954731 312.276276,226.954731 C312.276276,226.954731 316.624625,220.297964 316.624625,218.002395 C316.624625,215.705949 314.679596,213.844311 312.28028,213.844311 C309.880965,213.844311 307.935936,215.705949 307.935936,218.002395 L307.935936,217.998563 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M290.346346,228.269222 C291.067067,230.461317 297.289289,235.573653 297.289289,235.573653 C297.289289,235.573653 299.355355,227.974132 298.638639,225.782036 C297.921055,223.590359 295.483047,222.370429 293.193193,223.057246 C290.90334,223.744063 289.628763,226.077544 290.346346,228.269222 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M274.682683,240.494371 C275.003003,242.770778 280.236236,248.818204 280.236236,248.818204 C280.236236,248.818204 283.615616,241.663234 283.295295,239.386826 C282.975755,237.110487 280.788718,235.513083 278.41041,235.818923 C276.032103,236.124762 274.363143,238.218032 274.682683,240.494371 L274.682683,240.494371 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M329.185185,212.495329 C327.463463,214.097246 319.443443,215.748982 319.443443,215.748982 C319.443443,215.748982 321.409409,208.126467 323.131131,206.528383 C324.852667,204.928279 327.603494,204.966884 329.275275,206.614611 C330.947056,208.262338 330.906722,210.895225 329.185185,212.495329 L329.185185,212.495329 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M324.648649,226.287904 C322.294294,226.736287 314.638639,223.954012 314.638639,223.954012 C314.638639,223.954012 320.620621,218.588743 322.970971,218.128862 C325.324953,217.681214 327.612379,219.144787 328.08008,221.397844 C328.547781,223.650901 327.018647,225.840256 324.664665,226.287904 L324.648649,226.287904 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M308.132132,241.211018 C305.861862,240.444551 300.708709,234.351138 300.708709,234.351138 C300.708709,234.351138 308.716717,232.603593 310.974975,233.354731 C312.474248,233.816471 313.595,235.018703 313.904124,236.496834 C314.213247,237.974965 313.662323,239.497462 312.464251,240.475969 C311.266179,241.454475 309.608622,241.73572 308.132132,241.211018 L308.132132,241.211018 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M292.976977,249.810778 C290.610611,249.427545 284.452452,244.25006 284.452452,244.25006 C284.452452,244.25006 292.024024,241.23018 294.39039,241.605749 C295.933634,241.835147 297.229475,242.839726 297.784462,244.236944 C298.339449,245.634161 298.068167,247.208983 297.07392,248.36172 C296.079674,249.514458 294.515479,250.067702 292.976977,249.810778 L292.976977,249.810778 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M307.935936,217.998563 C307.935936,220.297964 312.276276,226.954731 312.276276,226.954731 C312.276276,226.954731 316.624625,220.297964 316.624625,218.002395 C316.624625,215.705949 314.679596,213.844311 312.28028,213.844311 C309.880965,213.844311 307.935936,215.705949 307.935936,218.002395 L307.935936,217.998563 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M290.346346,228.269222 C291.067067,230.461317 297.289289,235.573653 297.289289,235.573653 C297.289289,235.573653 299.355355,227.974132 298.638639,225.782036 C297.921055,223.590359 295.483047,222.370429 293.193193,223.057246 C290.90334,223.744063 289.628763,226.077544 290.346346,228.269222 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M274.682683,240.494371 C275.003003,242.770778 280.236236,248.818204 280.236236,248.818204 C280.236236,248.818204 283.615616,241.663234 283.295295,239.386826 C282.975755,237.110487 280.788718,235.513083 278.41041,235.818923 C276.032103,236.124762 274.363143,238.218032 274.682683,240.494371 L274.682683,240.494371 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.25"
        />
        <path
          d="M274.830831,256.379401 C274.830831,256.379401 276.800801,236.934132 288.540541,226.594491 C293.492302,222.285653 296.850193,216.555725 298.11011,210.26491 C298.686441,207.272834 298.973274,204.236266 298.967167,201.193772"
          id="Path"
          stroke="#535461"
          strokeWidth="2"
        />
        <path
          d="M306.322322,194.648144 C305.425425,196.778922 298.794795,201.400719 298.794795,201.400719 C298.794795,201.400719 297.369369,193.667066 298.266266,191.54012 C298.818995,190.125064 300.130112,189.108268 301.691033,188.88415 C303.251954,188.660032 304.817073,189.263855 305.77928,190.461395 C306.741488,191.658936 306.949383,193.261765 306.322322,194.648144 L306.322322,194.648144 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M308.016016,209.015569 C306.054054,210.337725 297.861862,210.766946 297.861862,210.766946 C297.861862,210.766946 301.065065,203.535329 303.015015,202.213174 C304.284577,201.358132 305.934294,201.216306 307.342733,201.841119 C308.751172,202.465933 309.704357,203.762462 309.843233,205.242317 C309.98211,206.722172 309.285578,208.160527 308.016016,209.015569 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M299.235235,229.066347 C296.832833,229.257964 289.545546,225.670898 289.545546,225.670898 C289.545546,225.670898 296.116116,220.972455 298.49049,220.777006 C300.882066,220.584401 302.983952,222.283896 303.185185,224.572934 C303.386418,226.861972 301.610794,228.873742 299.219219,229.066347 L299.235235,229.066347 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M289.021021,242.805269 C286.698699,243.38012 278.874875,241.027066 278.874875,241.027066 C278.874875,241.027066 284.516517,235.328383 286.838839,234.753533 C288.352973,234.346394 289.978777,234.754312 291.089517,235.820038 C292.200257,236.885765 292.622462,238.442859 292.193375,239.891074 C291.764288,241.339289 290.550923,242.452447 289.021021,242.801437 L289.021021,242.805269 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M289.229229,207.915689 C290.198198,210.015808 296.988989,214.430659 296.988989,214.430659 C296.988989,214.430659 298.146146,206.658683 297.173173,204.558563 C296.173797,202.505324 293.641237,201.595427 291.477104,202.512082 C289.31297,203.428737 288.313531,205.834671 289.229229,207.923353 L289.229229,207.915689 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M277.497497,224.130299 C279.079079,225.85485 286.934935,228.115928 286.934935,228.115928 C286.934935,228.115928 285.60961,220.366946 284.024024,218.642395 C283.008269,217.49685 281.425847,216.964886 279.884764,217.250896 C278.343681,217.536907 277.083672,218.5964 276.588864,220.022291 C276.094056,221.448182 276.441423,223.018657 277.497497,224.130299 L277.497497,224.130299 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M268.352352,241.383473 C269.60961,243.341796 276.952953,246.836886 276.952953,246.836886 C276.952953,246.836886 277.013013,238.988263 275.751752,237.02994 C274.939232,235.76415 273.482892,235.009401 271.931322,235.05 C270.379751,235.090599 268.96867,235.920378 268.22962,237.226767 C267.490569,238.533156 267.535828,240.117683 268.348348,241.383473 L268.352352,241.383473 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="149.817818"
          cy="312.354491"
          rx="47.5995996"
          ry="7.63784431"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="243.507508"
          cy="253.723593"
          rx="47.5995996"
          ry="7.63784431"
        />
        <polygon
          id="Path"
          fill="#B77B7F"
          fillRule="nonzero"
          points="246.666667 152.921677 246.622623 154.412455 243.915916 245.821317 239.367367 245.821317 241.597598 154.412455 241.641642 152.691737"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="273.001001 230.357844 269.593594 230.35018 218.966967 230.246707 216.268268 230.242874 217.705706 226.004311 272.640641 226.004311"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="246.666667 152.921677 246.622623 154.412455 241.597598 154.412455 241.641642 152.691737"
        />
        <rect
          id="Rectangle"
          fill="#B77B7F"
          fillRule="nonzero"
          x="240.148148"
          y="150.687425"
          width="8.43643644"
          height="3.03904192"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="219.415415 226.004311 218.966967 230.246707 216.268268 230.242874 217.705706 226.004311"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="226.682683 150.62994 226.542543 151.948263 215.311311 257.965988 210.166166 257.732216 222.002002 151.948263 222.134134 150.74491"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="273.001001 230.357844 269.593594 230.35018 269.133133 226.004311 272.640641 226.004311"
        />
        <polygon
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
          points="278.386386 257.732216 273.237237 257.965988 262.01001 151.948263 261.86987 150.62994 266.414414 150.74491 266.546547 151.948263"
        />
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          fillRule="nonzero"
          x="186.826827"
          y="46.102994"
          width="113.457457"
          height="104.124551"
        />
        <path
          d="M245.76977,11.2785629 L245.76977,36.422515 L241.345345,36.422515 L241.345345,11.2785629 C241.310758,10.500613 241.724675,9.76716263 242.423379,9.36831586 C243.122083,8.96946909 243.993032,8.96946909 244.691736,9.36831586 C245.39044,9.76716263 245.804357,10.500613 245.76977,11.2785629 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="241.341341"
          y="34.1346108"
          width="4.42842843"
          height="2.28790419"
        />
        <path
          d="M247.507508,35.851497 L247.507508,44.1523353 L239.631624,44.1523353 L239.631632,35.851497 C239.630563,35.5777734 239.743696,35.3149654 239.94592,35.1214123 C240.148143,34.9278591 240.422724,34.8195755 240.708709,34.8205988 L246.438438,34.8205988 C247.030162,34.8248097 247.507524,35.2851275 247.507508,35.851497 L247.507508,35.851497 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          cx="243.555556"
          cy="40.0900599"
          rx="1.67367367"
          ry="1.60191617"
        />
        <ellipse
          id="Oval"
          fill="#B77B7F"
          fillRule="nonzero"
          cx="243.555556"
          cy="39.7451497"
          rx="1.67367367"
          ry="1.60191617"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="239.607608"
          y="43.1252695"
          width="7.8998999"
          height="1.0308982"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="236.376376"
          y="44.5010778"
          width="14.3623624"
          height="2.29173653"
        />
        <rect
          id="Rectangle"
          fill="#DDA2A6"
          fillRule="nonzero"
          x="236.376376"
          y="43.8112575"
          width="14.3623624"
          height="2.29173653"
        />
        <path
          d="M214.502503,147.54491 L274.822823,147.54491 C276.260201,147.54491 277.425425,148.660177 277.425425,150.035928 L277.425425,150.58012 L211.8999,150.58012 L211.8999,150.035928 C211.8999,148.660177 213.065125,147.54491 214.502503,147.54491 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="222.134134 150.74491 226.682683 150.62994 226.542543 151.948263 222.002002 151.948263"
        />
        <rect
          id="Rectangle"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          x="240.148148"
          y="150.687425"
          width="8.43643644"
          height="1.26083832"
        />
        <polygon
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
          points="266.546547 151.948263 262.01001 151.948263 261.86987 150.62994 266.414414 150.74491"
        />
        <path
          d="M214.502503,148.223234 L274.822823,148.223234 C276.260201,148.223234 277.425425,149.3385 277.425425,150.714251 L277.425425,151.258443 L211.8999,151.258443 L211.8999,150.714251 C211.8999,150.053593 212.174102,149.419992 212.662185,148.952836 C213.150267,148.485679 213.812249,148.223234 214.502503,148.223234 L214.502503,148.223234 Z"
          id="Path"
          fill="#DDA2A6"
          fillRule="nonzero"
        />
        <path
          d="M201.277277,99.8821557 C200.368368,99.4222754 190.466466,92.2634731 190.466466,92.2634731 L174.486486,82.5638323 C174.486486,82.5638323 174.402402,82.3338922 174.25025,81.9391617 C178.634635,77.1755689 177.677678,70.2620359 173.217217,65.4026347 C167.811812,59.508503 143.387387,46.8196407 136.028028,57.6728144 C134.998999,59.2057485 134.962963,60.9456287 134.694695,62.6318563 C134.066066,66.5676647 132.04004,70.3808383 128.860861,73.5923353 C126.41041,76.0718563 123.195195,78.3559281 121.785786,81.1611976 C121.785786,81.1267066 121.757758,81.0922156 121.745746,81.0538922 C121.405522,81.655145 121.158683,82.3006536 121.013013,82.9700599 C120.312312,86.3923353 122.714715,89.6728144 123.991992,93.0031138 C124.420722,94.13089 124.731878,95.2964821 124.920921,96.4828743 C124.952953,96.2452695 124.980981,96.011497 125.009009,95.7738922 C125.320294,97.4631829 125.426438,99.181261 125.325325,100.893892 C116.456456,102.622275 116.452452,117.142994 116.452452,117.142994 C116.452452,117.142994 115.359359,122.914491 115.543544,124.995449 C115.727728,127.076407 115.723724,131.575569 115.723724,132.66012 C115.723724,133.744671 114.630631,140.508743 114.522523,141.321198 C114.523584,141.332672 114.523584,141.344214 114.522523,141.355689 C114.362362,142.24479 112.700701,146.529341 116.716717,147.487425 C116.996997,147.556407 117.293293,147.613892 117.601602,147.667545 C117.773774,151.135808 118.086086,158.398084 117.80981,160.015329 C117.80981,160.015329 119.271271,169.772455 120.484484,172.251976 C121.251666,173.705866 122.149263,175.093269 123.167167,176.398563 C123.079073,176.992681 122.869544,177.564366 122.550551,178.080958 C121.92993,178.935569 122.25025,179.636886 123.287287,179.939641 C123.251251,180.234731 123.211211,180.568144 123.167167,180.943713 C122.722723,184.707066 122.058058,192.187784 123.187187,195.977964 C124.736737,201.174611 124.828829,202.906826 124.828829,202.906826 C124.828829,202.906826 124.828829,204.462754 125.469469,205.328862 C126.11011,206.19497 127.291291,214.250539 127.291291,215.549701 C127.291291,216.848862 130.39039,228.537485 129.477477,231.308263 C128.564565,234.079042 129.297297,237.976527 129.297297,237.976527 C129.297297,237.976527 128.748749,244.817246 128.096096,246.288862 C127.443443,247.760479 127.183183,271.486467 128.184184,277.633533 C129.185185,283.780599 129.825826,288.889102 129.825826,288.889102 C129.825826,288.889102 129.189189,294.518802 129.733734,295.296766 C130.278278,296.074731 131.283283,300.754012 130.554555,301.010778 C129.825826,301.267545 129.461461,303.176048 129.461461,303.176048 C129.84683,303.736751 130.262475,304.277845 130.706707,304.797126 C130.42578,304.703279 130.151585,304.591902 129.885886,304.463713 C130.174174,304.846946 130.606607,305.391138 131.139139,305.996647 L130.638639,312.224192 C130.595261,312.725512 130.932129,313.184967 131.439439,313.316407 C134.697061,314.163948 138.177671,313.227273 140.496496,310.879042 C145.053053,306.464192 146.602603,307.069701 147.423423,304.387066 C147.511512,304.099641 147.587588,303.816048 147.651652,303.547784 C148.24024,301.156407 145.577578,299.378204 143.459459,300.397605 C143.751752,298.504431 143.97998,296.354491 143.75976,295.139641 C143.303303,292.629461 143.395395,286.049341 143.395395,286.049341 L142.758759,254.528383 C142.758759,254.528383 143.93994,248.293174 145.309309,245.871138 C146.678679,243.449102 146.510511,234.960479 146.510511,234.960479 L148.06006,207.076407 L149.517518,193.483114 C149.517518,193.483114 150.974975,188.807665 152.796797,194.004311 C152.796797,194.004311 151.795796,204.478084 152.252252,206.992096 C152.708709,209.506108 153.345345,221.712096 152.888889,224.394731 C152.432432,227.077365 150.43043,241.801198 151.687688,245.522395 C152.944945,249.243593 154.346346,253.754251 154.066066,255.229701 C153.785786,256.70515 152.864865,288.651497 152.864865,288.651497 C152.864865,288.651497 155.327327,294.783234 153.505506,296.791377 C151.683684,298.799521 153.413413,306.755449 153.413413,306.755449 C153.413413,306.755449 153.633634,306.90491 154.01001,307.111856 L153.957958,307.77485 L153.385385,314.937485 C153.343272,315.439338 153.679241,315.899176 154.186186,316.033533 C157.443811,316.881952 160.924893,315.94515 163.243243,313.596168 C167.7998,309.177485 169.349349,309.786826 170.17017,307.100359 C170.258258,306.812934 170.334334,306.533174 170.402402,306.261078 C171.043043,303.651257 167.7998,301.758084 165.62963,303.463473 L165.521522,303.551617 C165.408138,303.643866 165.289144,303.729605 165.165165,303.808383 C165.107575,303.848975 165.047399,303.886093 164.984985,303.919521 C165.441441,301.942036 166.106106,298.554251 165.785786,296.967665 C165.329329,294.62994 166.238238,287.532455 166.238238,287.532455 C166.238238,287.532455 168.880881,279.043832 168.972973,275.652216 L169.701702,248.638084 C169.701702,248.638084 169.613614,237.639281 169.977978,234.956647 C170.342342,232.274012 173.257257,209.065389 176.172172,202.136527 C178.41041,196.832575 179.411411,183.296766 178.818819,176.433054 C178.786787,176.095808 178.754755,175.77006 178.714715,175.467305 C182.29029,172.941796 182.646647,168.741557 182.646647,168.741557 C182.646647,168.741557 179.363363,162.74012 176.204204,160.199281 C173.045045,157.658443 172.364364,153.289581 172.476476,151.430898 C172.530143,150.298294 172.140359,149.187276 171.383383,148.31521 C171.383383,148.31521 169.925926,143.812216 168.952953,143.352335 C168.873363,143.313556 168.801529,143.261666 168.740741,143.199042 C168.08008,142.520719 168.588589,140.581557 168.588589,140.581557 L168.588589,140.52024 C168.704705,140.071856 169.389389,137.166946 169.185185,136.423473 C168.940941,135.618683 169.305305,131.805509 169.305305,131.805509 C169.305305,131.805509 171.615616,125.225389 171.251251,120.028743 C170.886887,114.832096 175.991992,115.295808 175.991992,115.295808 L191.755756,115.138683 L193.54955,115.138683 C194.182082,114.62461 194.76012,114.052101 195.275275,113.429461 C198.278278,113.088383 204.352352,112.003832 205.033033,108.830659 C205.957958,104.618922 202.19019,100.345868 201.277277,99.8821557 Z M128.244244,147.924311 L128.352352,145.283832 C128.724725,145.590419 128.972973,145.785868 128.972973,145.785868 C129.173996,146.476737 129.183656,147.205792 129.001001,147.901317 C128.802901,148.563033 128.300165,149.102069 127.635636,149.365269 C127.559422,149.396979 127.485808,149.43413 127.415415,149.476407 L127.263263,147.985629 L128.244244,147.924311 Z M185.421421,101.553054 C184.752753,101.265629 182.502503,101.323114 181.345345,101.323114 C180.188188,101.323114 178.31031,100.399521 178.31031,100.399521 C177.90991,99.6522156 175.695696,99.2076647 173.725726,98.9547305 C172.228228,95.4213174 170.122122,91.9760479 169.837838,88.2931737 C169.837838,88.1590419 169.837838,88.0249102 169.817818,87.8907784 L170.046046,88.274012 C170.046046,88.274012 179.223223,93.8768862 180.256256,95.5554491 C181.057057,96.8354491 184.912913,99.6943713 186.698699,100.974371 C186.452812,101.281421 186.108024,101.502323 185.717718,101.602874 C185.616016,101.613437 185.513272,101.596161 185.421421,101.553054 Z"
          id="Shape"
          fill="url(#linearGradient-1)"
          fillRule="nonzero"
        />
        <path
          d="M170.266266,306.284072 C170.198198,306.552335 170.126126,306.832096 170.038038,307.115689 C169.237237,309.798323 167.703704,309.177485 163.231231,313.557844 C160.959893,315.888094 157.525922,316.820838 154.314314,315.97988 C153.806627,315.851394 153.468836,315.392296 153.513514,314.891497 L154.078078,307.786347 L154.346346,304.367904 C154.346346,304.367904 161.489489,306.284072 165.125125,303.850539 C165.247093,303.770783 165.364699,303.685081 165.477477,303.593772 C165.505527,303.569555 165.532255,303.543972 165.557558,303.517126 C166.519608,302.75483 167.881776,302.662834 168.946133,303.288275 C170.010489,303.913715 170.541168,305.117991 170.266266,306.284072 L170.266266,306.284072 Z"
          id="Path"
          fill="#67647E"
          fillRule="nonzero"
        />
        <path
          d="M147.843844,303.601437 C147.775776,303.869701 147.703704,304.149461 147.615616,304.433054 C146.814815,307.115689 145.281281,306.49485 140.808809,310.87521 C138.537471,313.205459 135.103499,314.138203 131.891892,313.297246 C131.384204,313.168759 131.046414,312.709661 131.091091,312.208862 L131.655656,305.103713 L131.923924,301.685269 C131.923924,301.685269 139.067067,303.601437 142.702703,301.167904 C142.824671,301.088148 142.942276,301.002446 143.055055,300.911138 C143.083104,300.88692 143.109833,300.861338 143.135135,300.834491 C144.097185,300.072195 145.459353,299.980199 146.52371,300.60564 C147.588067,301.231081 148.118746,302.435357 147.843844,303.601437 Z"
          id="Path"
          fill="#67647E"
          fillRule="nonzero"
        />
        <path
          d="M140.464464,304.666826 L140.752753,308.361198 C136.652653,312.281677 131.771772,306.44503 130.342342,304.528862 C134.102102,306.383713 140.464464,304.666826 140.464464,304.666826 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M164.564565,306.169102 L165.101101,305.828024 C161.357357,311.277605 155.795796,308.763593 154.062062,307.786347 L154.33033,304.367904 C154.33033,304.367904 161.473473,306.284072 165.109109,303.850539 C164.824825,305.184192 164.564565,306.169102 164.564565,306.169102 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M175.967968,202.991138 C173.093093,209.862515 170.222222,232.883353 169.861862,235.565988 C169.501502,238.248623 169.593594,249.14012 169.593594,249.14012 L168.872873,275.924311 C168.780781,279.277605 166.178178,287.697246 166.178178,287.697246 C166.178178,287.697246 165.281281,294.741078 165.72973,297.059641 C166.178178,299.378204 164.564565,305.490778 164.564565,305.490778 L165.101101,305.145868 C160.612613,311.660838 153.521522,306.778443 153.521522,306.778443 C153.521522,306.778443 151.815816,298.876168 153.613614,296.898683 C155.411411,294.921198 152.984985,288.823952 152.984985,288.823952 C152.984985,288.823952 153.881882,257.122874 154.15015,255.662754 C154.418418,254.202635 153.073073,249.734132 151.815816,246.03976 C150.558559,242.345389 152.536537,227.740359 152.984985,225.076886 C153.433433,222.413413 152.804805,210.299401 152.356356,207.808383 C151.907908,205.317365 152.892893,194.92024 152.892893,194.92024 C151.099099,189.765749 149.661662,194.406707 149.661662,194.406707 L148.224224,207.892695 L146.698699,235.558323 C146.698699,235.558323 146.878879,243.989461 145.533534,246.384671 C144.188188,248.77988 143.019019,254.972934 143.019019,254.972934 L143.647648,286.248623 C143.647648,286.248623 143.55956,292.763593 144.008008,295.266108 C144.456456,297.768623 143.019019,304.203114 143.019019,304.203114 C137.993994,315.535329 129.921922,303.248862 129.921922,303.248862 C129.921922,303.248862 130.282282,301.359521 130.998999,301.102754 C131.715716,300.845988 130.730731,296.20503 130.198198,295.430898 C129.665666,294.656766 130.286286,289.073054 130.286286,289.073054 C130.286286,289.073054 129.657658,284.006707 128.684685,277.905629 C127.711712,271.804551 127.967968,248.266347 128.596597,246.806228 C129.225225,245.346108 129.761762,238.559042 129.761762,238.559042 C129.761762,238.559042 129.045045,234.692216 129.941942,231.940599 C130.838839,229.188982 127.787788,217.596168 127.787788,216.304671 C127.787788,215.013174 126.622623,207.026587 125.993994,206.168144 C125.365365,205.309701 125.365365,203.761437 125.365365,203.761437 C125.365365,203.761437 125.277277,202.044551 123.763764,196.89006 C122.650651,193.126707 123.307307,185.707305 123.743744,181.970778 C123.8999,180.587305 124.036036,179.705868 124.036036,179.705868 C124.036036,179.705868 175.515516,171.715449 177.56957,173.520479 C178.05005,173.945868 178.37037,175.405988 178.558559,177.486946 C179.171171,184.293174 178.162162,197.744671 175.967968,202.991138 Z"
          id="Path"
          fill="#444053"
          fillRule="nonzero"
        />
        <path
          d="M156.484484,241.621078 C156.724725,241.621078 162.41041,242.080958 164.492492,241.678563 C166.574575,241.276168 156.484484,241.621078 156.484484,241.621078 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M156.904905,244.828743 C156.904905,244.828743 164.756757,246.147066 165.157157,245.461078 C165.557558,244.77509 156.904905,244.828743 156.904905,244.828743 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M132.908909,243.452934 C132.908909,243.452934 136.976977,243.625389 139.191191,244.602635 C141.405405,245.57988 132.908909,243.452934 132.908909,243.452934 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M118.126126,147.119521 C118.126126,147.119521 118.782783,159.087904 118.426426,161.207186 C118.426426,161.207186 119.85986,170.887665 121.057057,173.348024 C122.254254,175.808383 124.828829,178.90491 124.828829,178.90491 L128.36036,155.144431 L127.51952,147.004551 L118.126126,147.119521 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          fill="#EFB7B9"
          fillRule="nonzero"
          cx="155.227227"
          cy="79.3638323"
          rx="13.8218218"
          ry="13.2292216"
        />
        <path
          d="M148.048048,85.5453892 C148.048048,85.5453892 143.73974,93.6239521 139.431431,97.4026347 C135.123123,101.181317 165.281281,105.477365 165.997998,105.477365 C166.714715,105.477365 160.612613,88.297006 161.68969,86.2237126 C162.766767,84.1504192 148.048048,85.5453892 148.048048,85.5453892 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <path
          d="M178.566567,177.486946 C177.889747,177.981609 177.142862,178.381622 176.348348,178.67497 C170.846847,180.736766 164.860861,183.599521 160.792793,182.457485 C156.724725,181.315449 148.108108,182.457485 148.108108,182.457485 C148.108108,182.457485 130.750751,181.081677 127.287287,181.882635 C125.70971,182.246707 124.484484,182.231377 123.683684,181.970778 C123.83984,180.587305 123.975976,179.705868 123.975976,179.705868 C123.975976,179.705868 175.515516,171.715449 177.56957,173.520479 C178.058058,173.945868 178.37037,175.405988 178.566567,177.486946 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M182.334334,169.852934 C182.334334,169.852934 181.857858,175.582275 176.348348,177.644072 C170.838839,179.705868 164.860861,182.568623 160.792793,181.426587 C156.724725,180.284551 148.108108,181.426587 148.108108,181.426587 C148.108108,181.426587 130.750751,180.050778 127.287287,180.851737 C123.823824,181.652695 122.018018,180.625629 123.095095,179.13485 C124.172172,177.644072 124.056056,172.719521 124.056056,170.657725 C124.056056,168.595928 122.854855,160.233772 123.931932,158.742994 C125.009009,157.252216 125.965966,151.526707 128.12012,150.606946 C128.775305,150.342867 129.270067,149.808714 129.465465,149.154491 C129.64352,148.464926 129.633871,147.743181 129.437437,147.058204 C129.437437,147.058204 129.073073,146.770778 128.572573,146.345389 C127.303303,145.260838 125.157157,143.248862 125.845846,142.589701 C126.802803,141.66994 125.845846,135.714491 125.845846,135.714491 C125.845846,135.714491 123.571572,131.13485 124.412412,129.417964 C125.253253,127.701078 117.109109,118.649102 117.109109,118.649102 C117.109109,118.649102 117.109109,103.074491 126.922923,102.384671 C126.922923,102.384671 133.865866,102.614611 134.702703,99.6368862 C135.53954,96.6591617 141.045045,94.9384431 141.045045,94.9384431 L153.613614,97.5750898 C153.613614,97.5750898 164.740741,99.874491 166.778779,98.491018 C168.816817,97.1075449 170.382382,100.322874 170.382382,100.322874 C170.382382,100.322874 177.321321,100.667784 178.038038,102.043593 C178.754755,103.419401 175.767768,116.817246 175.767768,116.817246 C175.767768,116.817246 170.738739,116.361198 171.099099,121.515689 C171.459459,126.67018 169.161161,133.200479 169.161161,133.200479 C169.161161,133.200479 168.800801,136.979162 169.041041,137.78012 C169.265265,138.51976 168.568569,141.401677 168.456456,141.846228 L168.456456,141.903713 C168.456456,141.903713 167.955956,143.81988 168.604605,144.502036 C168.664718,144.563755 168.735067,144.615549 168.812813,144.655329 C169.773774,145.111377 171.215215,149.57988 171.215215,149.57988 C171.96246,150.447299 172.346324,151.549515 172.292292,152.672575 C172.176176,154.508263 172.892893,158.857964 176.004004,161.379641 C179.115115,163.901317 182.334334,169.852934 182.334334,169.852934 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M128.956957,143.325509 L128.956957,143.812216 L128.740741,149.177485 C128.740741,149.177485 121.377377,149.748503 117.369369,148.794251 C113.361361,147.84 115.047047,143.582275 115.207207,142.700838 C115.208673,142.689384 115.208673,142.677801 115.207207,142.666347 C115.323323,141.861557 116.408408,135.162635 116.408408,134.074251 C116.408408,132.985868 116.408408,128.517365 116.228228,126.455569 C116.048048,124.393772 117.109109,118.649102 117.109109,118.649102 L117.885886,117.737006 L126.318318,120.829701 L128.956957,143.325509 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M128.936937,143.823713 L128.720721,149.188982 C128.720721,149.188982 121.357357,149.76 117.349349,148.805749 C113.341341,147.851497 115.027027,143.593772 115.187187,142.712335 L128.936937,143.823713 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M129.465465,149.158323 C129.64352,148.468759 129.633871,147.747014 129.437437,147.062036 C129.437437,147.062036 129.073073,146.774611 128.572573,146.349222 C134.910911,145.502275 160.012012,142.206467 168.464464,141.846228 L168.464464,141.903713 C168.464464,141.903713 167.963964,143.81988 168.612613,144.502036 L129.465465,149.158323 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M169.409409,153.289581 C169.409409,153.289581 170.966967,161.720719 165.161154,164.68703 C165.157157,164.702275 168.452452,160.521198 169.409409,153.289581 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M131.411411,164.928383 C131.411411,164.928383 145.425425,162.628982 148.168168,164.41485 C150.910911,166.200719 131.411411,164.928383 131.411411,164.928383 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M164.564565,112.751138 C164.564565,112.751138 162.41041,121.228263 164.024024,123.17509 C165.637638,125.121916 164.564565,112.751138 164.564565,112.751138 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M123.991992,105.822275 C123.991992,105.822275 125.965966,108.972455 124.768769,112.237605 C123.571572,115.502754 123.991992,105.822275 123.991992,105.822275 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M119.911912,133.430419 C119.911912,133.430419 122.426426,134.85988 121.58959,137.094132 C120.752753,139.328383 119.911912,133.430419 119.911912,133.430419 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M119.683684,126.90012 C119.683684,126.90012 122.014014,128.103473 122.314314,129.877844 C122.614615,131.652216 119.683684,126.90012 119.683684,126.90012 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M154.27027,195.399281 C154.27027,195.399281 168.932933,196.832575 171.863864,193.50994 C171.863864,193.529102 158.638639,196.031617 154.27027,195.399281 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M128.956957,194.598323 C128.956957,194.598323 144.696697,198.150898 147.807808,195.341796 C147.807808,195.341796 134.282282,196.31521 128.956957,194.598323 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M155.407407,200.044072 C155.407407,200.044072 161.98999,200.044072 165.041041,200.216527 C168.092092,200.388982 155.407407,200.044072 155.407407,200.044072 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M130.034034,202.726707 C130.034034,202.726707 133.265265,206.221796 136.916917,205.593293 C140.568569,204.96479 130.034034,202.726707 130.034034,202.726707 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M136.38038,59.6464671 C135.367367,61.1525749 135.331331,62.8962874 135.067067,64.5671856 C134.45045,68.4723353 132.452452,72.2548503 129.325325,75.4433533 C126.454454,78.3635928 122.518519,81.0117365 121.773774,84.5796407 C121.069069,87.9674251 123.459459,91.2287425 124.712713,94.5437126 C128.016016,103.239281 123.403403,112.36024 122.058058,121.335569 C121.685686,123.81509 122.134134,126.984431 125.325325,127.808383 C126.322322,128.068982 127.463463,128.034491 128.36036,128.448383 C129.561562,129.00024 129.92993,130.146108 130.15015,131.177006 C130.953295,134.864547 131.23076,138.639236 130.974975,142.398084 C130.830831,144.505868 130.670671,146.931737 132.752753,148.380359 C133.697698,149.043353 134.970971,149.380599 136.2002,149.698683 C139.479479,150.545629 143.71972,151.231617 145.92993,149.242635 C146.858859,148.411018 147.207207,147.238323 148.364364,146.579162 C150.098098,145.594251 152.556557,146.261078 154.738739,146.364551 C159.219219,146.579162 163.335335,144.06515 165.101101,141.033772 C166.866867,138.002395 166.702703,134.518802 166.062062,131.24982 C165.421421,127.980838 164.276276,124.73485 164.196196,121.416048 C164.168168,120.266347 164.276276,119.097485 164.964965,118.078084 C166.298298,116.104431 169.401401,115.207665 171.523524,113.655569 C175.499499,110.742994 175.487487,105.971737 174.042042,101.978443 C172.596597,97.9851497 170.002002,94.1566467 169.681682,90.0292216 C169.538723,89.031465 169.745737,88.0165093 170.27027,87.1434731 C170.838839,86.3041916 171.831832,85.6756886 172.672673,84.9820359 C178.474474,80.2912575 177.78979,72.5882635 172.992993,67.3149701 C167.683684,61.4706587 143.627628,48.8814371 136.38038,59.6464671 Z"
          id="Path"
          fill="#E3787D"
          fillRule="nonzero"
        />
        <g
          id="Group"
          opacity="0.1"
          transform="translate(121.321321, 72.814371)"
          fill="#000000"
          fillRule="nonzero"
        >
          <path
            d="M4.12812813,25.3394012 C4.58058058,21.8558084 4.4964965,18.4028743 3.21121121,15.0112575 C2.57857858,13.348024 1.66166166,11.6962874 0.992992993,10.0292216 C0.658973369,10.6319759 0.416298999,11.27717 0.272272272,11.9453892 C-0.432432432,15.3331737 1.95795796,18.594491 3.21121121,21.9094611 C3.63310015,23.0213845 3.94020477,24.1701805 4.12812813,25.3394012 Z"
            id="Path"
          />
          <path
            d="M9.47347347,62.8656287 C9.72860833,59.1069582 9.45250883,55.3325245 8.65265265,51.6445509 C8.42842843,50.6136527 8.06006006,49.4716168 6.85885886,48.9197605 C5.96196196,48.5058683 4.82082082,48.5365269 3.82382382,48.2797605 C2.5824848,47.9949206 1.5481054,47.1774379 1.02102102,46.0646707 C0.836836837,46.9384431 0.676676677,47.8083832 0.544544545,48.6821557 C0.172172172,51.1616766 0.620620621,54.331018 3.81181181,55.1549701 C4.80880881,55.4117365 5.94994995,55.3772455 6.84684685,55.7911377 C8.04804805,56.342994 8.41641642,57.4888623 8.64064064,58.5197605 C9.00794579,60.2300965 9.26468941,61.9604871 9.40940941,63.7010778 C9.43743744,63.417485 9.45345345,63.1415569 9.47347347,62.8656287 Z"
            id="Path"
          />
          <path
            d="M43.6036036,61.5051497 C41.8338338,64.548024 37.7177177,67.0505389 33.2372372,66.8359281 C31.0550551,66.7286228 28.5965966,66.0694611 26.8668669,67.0505389 C25.7097097,67.7058683 25.3573574,68.8823952 24.4284284,69.714012 C22.2182182,71.6876647 17.977978,71.017006 14.6986987,70.1700599 C13.4694695,69.8481437 12.2002002,69.5147305 11.2512513,68.8517365 C10.3469128,68.2151243 9.73667311,67.2668597 9.54954955,66.2074251 C9.57357357,67.3839521 9.54954955,68.5643114 9.47347347,69.7408383 C9.32932933,71.8486228 9.16916917,74.274491 11.2512513,75.7269461 C12.2002002,76.3861078 13.4694695,76.7233533 14.6986987,77.0414371 C17.977978,77.8883832 22.2182182,78.5743713 24.4284284,76.5853892 C25.3573574,75.7537725 25.7097097,74.5810778 26.8668669,73.9027545 C28.5965966,72.9178443 31.0550551,73.5846707 33.2372372,73.6881437 C37.7177177,73.9027545 41.8338338,71.3887425 43.6036036,68.3573653 C45.3013013,65.4294611 45.2252252,62.1183234 44.6326326,58.9566467 C44.4094142,59.8461241 44.0633594,60.7031669 43.6036036,61.5051497 Z"
            id="Path"
          />
          <path
            d="M51.1871872,5.46874251 C50.3303303,6.15856287 49.3373373,6.7908982 48.7847848,7.63017964 C48.2602519,8.50321575 48.0532376,9.51817175 48.1961962,10.5159281 C48.3124853,11.7700071 48.5895071,13.0056329 49.021021,14.1949701 C49.687827,13.5143186 50.4182619,12.8934504 51.2032032,12.3401198 C55.1271271,9.17077844 56.0800801,4.62179641 54.8068068,0.375568862 C54.134973,2.37013258 52.8786022,4.1379743 51.1871872,5.46874251 Z"
            id="Path"
          />
          <path
            d="M50.022022,34.1231138 C47.9039039,35.6752096 44.7967968,36.5758084 43.4674675,38.5494611 C42.7747748,39.5688623 42.6666667,40.7453892 42.6946947,41.8835928 C42.7439307,43.2238866 42.9154202,44.5575002 43.2072072,45.8692216 C43.2829794,45.7141584 43.3699431,45.5643348 43.4674675,45.4208383 C44.7967968,43.4471856 47.9039039,42.5504192 50.022022,40.9983234 C53.6536537,38.3386826 53.957958,34.1307784 52.8848849,30.3789222 C52.3404633,31.8715116 51.3437846,33.1750169 50.022022,34.1231138 Z"
            id="Path"
          />
        </g>
        <path
          d="M193.105105,115.100359 C193.105105,115.100359 203.459459,114.586826 204.356356,110.405749 C205.253253,106.224671 201.553554,101.974611 200.648649,101.526228 C199.743744,101.077844 189.981982,93.9650299 189.981982,93.9650299 L174.246246,84.3458683 C174.246246,84.3458683 166.706707,63.6512575 165.037037,71.5726946 C163.367367,79.4941317 169.885886,90.0138922 169.885886,90.0138922 C169.885886,90.0138922 178.918919,95.5707784 179.935936,97.2301796 C180.952953,98.8895808 187.179179,103.243114 187.179179,103.243114 L193.105105,115.100359 Z"
          id="Path"
          fill="#EFB7B9"
          fillRule="nonzero"
        />
        <path
          d="M198.670671,108.34012 C196.22022,114.299401 193.045045,116.648623 193.045045,116.648623 L191.279279,116.648623 L175.755756,116.801916 L173.965966,112.122635 L176.48048,101.982275 L178.034034,102.043593 C178.034034,102.043593 179.891892,102.959521 181.025025,102.959521 C182.158158,102.959521 184.38038,102.902036 185.029029,103.185629 C185.119652,103.227994 185.221679,103.242709 185.321321,103.227784 C185.90991,103.170299 186.522523,102.327186 186.522523,102.327186 C186.522523,102.327186 201.125125,102.384671 198.670671,108.34012 Z"
          id="Path"
          fill="#A36468"
          fillRule="nonzero"
        />
        <path
          d="M198.670671,108.34012 C196.22022,114.299401 193.045045,116.648623 193.045045,116.648623 L191.279279,116.648623 C192.2002,114.287904 194.142142,109.443832 194.882883,108.32479 C195.607608,107.267066 189.105105,104.634251 185.301301,103.212455 C185.88989,103.15497 186.502503,102.311856 186.502503,102.311856 C186.502503,102.311856 201.125125,102.384671 198.670671,108.34012 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="36.3643644"
          cy="292.844072"
          rx="17.6896897"
          ry="3.31113772"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="331.243243"
          cy="271.003593"
          rx="12.8848849"
          ry="2.41053892"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="387.095095"
          cy="280.772216"
          rx="12.8848849"
          ry="2.41053892"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="300.612613"
          cy="300.891976"
          rx="12.8848849"
          ry="2.41053892"
        />
        <path
          d="M53.0810811,200.929341 C53.0810811,200.929341 55.97998,204.558563 51.7437437,210.031138 C47.5075075,215.503713 44.02002,220.125509 45.4374374,223.54012 C45.4374374,223.54012 51.8238238,213.372934 57.025025,213.231138 C62.2262262,213.089341 58.8028028,207.045749 53.0810811,200.929341 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M53.0810811,200.929341 C53.3346999,201.283669 53.5342386,201.670799 53.6736737,202.079042 C58.7467467,207.785389 61.4494494,213.108503 56.5725726,213.242635 C52.032032,213.365269 46.5825826,221.141078 45.2772773,223.103234 C45.3190623,223.255793 45.3712256,223.405573 45.4334334,223.551617 C45.4334334,223.551617 51.8198198,213.384431 57.021021,213.242635 C62.2222222,213.100838 58.8028028,207.045749 53.0810811,200.929341 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M58.4664665,205.551138 C58.4664665,206.827305 58.3183183,207.850539 58.1341341,207.850539 C57.9499499,207.850539 57.7977978,206.815808 57.7977978,205.551138 C57.7977978,204.286467 57.985986,204.876647 58.1701702,204.876647 C58.3543544,204.876647 58.4664665,204.259641 58.4664665,205.551138 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M60.3163163,207.076407 C59.1471471,207.685749 58.1261261,208.057485 58.038038,207.900359 C57.9499499,207.743234 58.8388388,207.133892 59.995996,206.513054 C61.1531532,205.892216 60.7047047,206.348263 60.7967968,206.513054 C60.8888889,206.677844 61.4854855,206.463234 60.3163163,207.076407 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M37.7817818,200.929341 C37.7817818,200.929341 34.8828829,204.558563 39.1191191,210.031138 C43.3553554,215.503713 46.8428428,220.125509 45.4374374,223.54012 C45.4374374,223.54012 39.031031,213.372934 33.8258258,213.231138 C28.6206206,213.089341 32.0600601,207.045749 37.7817818,200.929341 Z"
          id="Path"
          className={classes.customFillColor}
          fillRule="nonzero"
        />
        <path
          d="M37.7817818,200.929341 C37.5281629,201.283669 37.328624,201.670799 37.1891892,202.079042 C32.1161161,207.785389 29.4134134,213.108503 34.2902903,213.242635 C38.8308308,213.365269 44.3003003,221.141078 45.5855856,223.103234 C45.5433293,223.255204 45.4925381,223.404883 45.4334334,223.551617 C45.4334334,223.551617 39.027027,213.384431 33.8218218,213.242635 C28.6166166,213.100838 32.0600601,207.045749 37.7817818,200.929341 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.1"
        />
        <path
          d="M32.3963964,205.551138 C32.3963964,206.827305 32.5445445,207.850539 32.7287287,207.850539 C32.9129129,207.850539 33.0650651,206.815808 33.0650651,205.551138 C33.0650651,204.286467 32.8768769,204.876647 32.6926927,204.876647 C32.5085085,204.876647 32.3963964,204.259641 32.3963964,205.551138 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <path
          d="M30.5465465,207.076407 C31.7197197,207.685749 32.7367367,208.057485 32.8288288,207.900359 C32.9209209,207.743234 32.028028,207.133892 30.8668669,206.513054 C29.7057057,205.892216 30.1581582,206.348263 30.0660661,206.513054 C29.973974,206.677844 29.3773774,206.463234 30.5465465,207.076407 Z"
          id="Path"
          fill="#FFD037"
          fillRule="nonzero"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="45.4294294"
          cy="246.829222"
          rx="30.2902903"
          ry="4.44934132"
        />
        <path
          d="M61.021021,218.653892 L60.8768769,219.803593 L60.6726727,221.401677 L60.5885886,222.068503 L60.3843844,223.670419 L60.2962963,224.337246 L60.0920921,225.935329 L57.7777778,244.115928 C57.5695696,245.740838 54.7987988,247.005509 51.4514515,247.005509 L39.4314314,247.005509 C36.0840841,247.005509 33.3173173,245.740838 33.1091091,244.115928 L30.7907908,225.931497 L30.5865866,224.333413 L30.5025025,223.666587 L30.2942943,222.064671 L30.2102102,221.397844 L30.006006,219.79976 L29.8618619,218.65006 C29.7457457,217.730299 31.2432432,216.956168 33.1371371,216.956168 L57.7697698,216.956168 C59.6396396,216.96 61.1411411,217.734132 61.021021,218.653892 Z"
          id="Path"
          fill="#65617D"
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="60.8728729 219.784431 60.6726727 221.386347 30.1861862 221.386347 29.985986 219.784431"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="60.5845846 222.053174 60.3843844 223.651257 30.4784785 223.651257 30.2742743 222.053174"
        />
        <polygon
          id="Path"
          fill="#9D9CB5"
          fillRule="nonzero"
          points="60.2962963 224.318084 60.0920921 225.916168 30.7667668 225.916168 30.5625626 224.318084"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="72.0680681"
          cy="48.1034731"
          rx="12.6126126"
          ry="12.0718563"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="45.6416416"
          cy="19.3609581"
          rx="7.80780781"
          ry="7.47305389"
        />
        <ellipse
          id="Oval"
          className={classes.customFillColor}
          fillRule="nonzero"
          opacity="0.1"
          cx="4.8048048"
          cy="36.0316168"
          rx="4.8048048"
          ry="4.5988024"
        />
      </g>
    </g>
  </svg>
);

const styles = (theme) => ({
  root: {
    width: "320px",
    height: "200px",

    [theme.breakpoints(600)]: {
      width: "400px",
      height: "320px",
    },
  },
  customFillColor: {
    fill: theme.colors.primary["500"],
  },
});

export default withStyles(styles)(BlankCanvas);
